// AuthContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

interface AuthContextType {
  isAuthenticated: boolean;
  accessPaths: string[];
  login: () => Promise<void>;
  logout: () => void;
  hasAccess: (path: string) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accessPaths, setAccessPaths] = useState<string[]>([]);

  const login = async () => {
    const res = await axios.get("http://localhost/access_path");
    setAccessPaths(res.data); // Example: ['karyawan', 'expense']
    setIsAuthenticated(true);
  };

  const logout = () => {
    setAccessPaths([]);
    setIsAuthenticated(false);
  };

  const hasAccess = (path: string) => accessPaths.includes(path);

  return (
    <AuthContext.Provider value={{ isAuthenticated, accessPaths, login, logout, hasAccess }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use the context
export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return true;
};
